/**
 * Internal dependencies
 */
import {
  Goal1,
  Goal2,
  Goal3,
  Goal4,
  Goal5,
  Goal6,
  Goal7,
  Goal8,
  Goal9,
  Goal10,
  Goal11,
  Goal12,
  Goal13,
  Goal14,
  Goal15,
  Goal16,
  Goal17,
} from './icons';

const variations = [
  {
    isDefault: true,
    name: 'goal-1',
    attributes: { service: 'goal-1' },
    title: 'Goal 1',
    icon: Goal1,
  },
  {
    name: 'goal-2',
    attributes: { service: 'goal-2' },
    title: 'Goal 2',
    icon: Goal2,
  },
  {
    name: 'goal-3',
    attributes: { service: 'goal-3' },
    title: 'Goal 3',
    icon: Goal3,
  },
  {
    name: 'goal-4',
    attributes: { service: 'goal-4' },
    title: 'Goal 4',
    icon: Goal4,
  },
  {
    name: 'goal-5',
    attributes: { service: 'goal-5' },
    title: 'Goal 5',
    icon: Goal5,
  },
  {
    name: 'goal-6',
    attributes: { service: 'goal-6' },
    title: 'Goal 6',
    icon: Goal6,
  },
  {
    name: 'goal-7',
    attributes: { service: 'goal-7' },
    title: 'Goal 7',
    icon: Goal7,
  },
  {
    name: 'goal-8',
    attributes: { service: 'goal-8' },
    title: 'Goal 8',
    icon: Goal8,
  },
  {
    name: 'goal-9',
    attributes: { service: 'goal-9' },
    title: 'Goal 9',
    icon: Goal9,
  },
  {
    name: 'goal-10',
    attributes: { service: 'goal-10' },
    title: 'Goal 10',
    icon: Goal10,
  },
  {
    name: 'goal-11',
    attributes: { service: 'goal-11' },
    title: 'Goal 11',
    icon: Goal11,
  },
  {
    name: 'goal-12',
    attributes: { service: 'goal-12' },
    title: 'Goal 12',
    icon: Goal12,
  },
  {
    name: 'goal-13',
    attributes: { service: 'goal-13' },
    title: 'Goal 13',
    icon: Goal13,
  },
  {
    name: 'goal-14',
    attributes: { service: 'goal-14' },
    title: 'Goal 14',
    icon: Goal14,
  },
  {
    name: 'goal-15',
    attributes: { service: 'goal-15' },
    title: 'Goal 15',
    icon: Goal15,
  },
  {
    name: 'goal-16',
    attributes: { service: 'goal-16' },
    title: 'Goal 16',
    icon: Goal16,
  },
  {
    name: 'goal-17',
    attributes: { service: 'goal-17' },
    title: 'Goal 17',
    icon: Goal17,
  },
];

export default variations;
